export default __webpack_public_path__ + "static/media/Clarx - Shakedown [NCS Release].c3f9a057.mp3";